export default __webpack_public_path__ + "static/media/9.d70d42e1.png";